<div class="app-dash">
    <div class="container">
        <div class="dash-flex">

            <div class="app-main">
                <div class="app-stats" *ngFor="let dt of inputData">
                    <div class="app-stats_card" (click)="goToApplication(dt)">
                        <div class="icon">
                            <img src="assets/ikons/colored/ikon-folder.svg" alt="" />
                        </div>
                        <div class="dtail">
                            <span class="dtail-title">{{dt.upi}}</span>
                            <span class="dtail-num">{{dt.permitTypes.name}} </span>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>